module.exports = __webpack_public_path__ + "static/media/warriors-640.be507e9b.jpg";